export default "__VITE_ASSET__uyPDaoI7__"